import React from 'react';
import { runtimeHooks } from './runtime-hooks.js';
import { STORES } from './data.jsx';
import { Icon } from './icons.jsx';
import { SUPPORT_AGENTS, TICKETS, TICKET_MESSAGES, setTICKETS } from './support-data.jsx';
// Suporte — Tab Tickets + Detalhe do Ticket + Tab Inbox

const TICKET_STATUS_CFG = {
  novo:               { label: 'Novo',         cls: 'info'    },
  aberto:             { label: 'Aberto',       cls: 'info'    },
  aguardando_cliente: { label: 'Ag. Cliente',  cls: 'warning' },
  aguardando_suporte: { label: 'Ag. Suporte',  cls: 'warning' },
  em_analise_tecnica: { label: 'Em Análise',   cls: 'neutral' },
  resolvido:          { label: 'Resolvido',    cls: 'success' },
  fechado:            { label: 'Fechado',      cls: 'neutral' },
};

const TICKET_PRIORITY_CFG = {
  baixa:   { label: 'Baixa',   cls: 'neutral' },
  media:   { label: 'Média',   cls: 'info'    },
  alta:    { label: 'Alta',    cls: 'warning' },
  urgente: { label: 'Urgente', cls: 'danger'  },
};

const TicketStatusBadge = ({ status, sm }) => {
  const c = TICKET_STATUS_CFG[status] || TICKET_STATUS_CFG.aberto;
  return <span className={`badge ${c.cls}`} style={sm ? { fontSize: 10 } : {}}><span className="dot" />{c.label}</span>;
};

const TicketPriorityBadge = ({ priority }) => {
  const c = TICKET_PRIORITY_CFG[priority] || TICKET_PRIORITY_CFG.media;
  return <span className={`badge ${c.cls}`} style={{ fontSize: 10 }}><span className="dot" />{c.label}</span>;
};

const SLAChip = ({ sla, time }) => {
  if (sla === 'vencido') return (
    <span style={{ display:'inline-flex',alignItems:'center',gap:4,padding:'2px 8px',borderRadius:20,background:'var(--danger-bg)',color:'var(--danger)',fontSize:11,fontWeight:600 }}>
      <Icon name="alert" size={11}/>{time}
    </span>
  );
  if (sla === 'vencendo') return (
    <span style={{ display:'inline-flex',alignItems:'center',gap:4,padding:'2px 8px',borderRadius:20,background:'var(--warning-bg)',color:'var(--warning)',fontSize:11,fontWeight:600 }}>
      <Icon name="clock" size={11}/>{time}
    </span>
  );
  return <span style={{ fontSize:11,color:'var(--text-muted)' }}>{time}</span>;
};

const AgentAvatar = ({ agent, size = 22 }) => {
  if (!agent) return <span style={{ fontSize:12,color:'var(--text-muted)' }}>—</span>;
  const found = (SUPPORT_AGENTS||[]).find(a => a.name === agent);
  const color = found?.color || 'var(--brand-navy)';
  const initials = agent.split(' ').map(w => w[0]).join('');
  return (
    <div style={{ display:'flex',alignItems:'center',gap:6 }}>
      <div style={{ width:size,height:size,borderRadius:'50%',background:color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:size*0.4,fontWeight:700,color:'white',flexShrink:0 }}>
        {initials}
      </div>
      <span style={{ fontSize:12 }}>{agent.split(' ')[0]}</span>
    </div>
  );
};

// ── Tab Tickets ───────────────────────────────────────────────────────────────
const TicketsTab = ({ onOpenDetail, onToast, tickets: ticketsProp, onTicketUpdate }) => {
  const [search, setSearch]           = React.useState('');
  const [filterStatus, setFilterStatus] = React.useState('');
  const [filterPriority, setFilterPriority] = React.useState('');
  const [filterChannel, setFilterChannel]   = React.useState('');
  const [quickFilter, setQuickFilter] = React.useState('');
  const [selected, setSelected]       = React.useState(null);

  const tickets = ticketsProp || TICKETS || [];

  const filtered = tickets.filter(t => {
    if (search) {
      const q = search.toLowerCase();
      if (!t.subject.toLowerCase().includes(q) && !t.tenant.toLowerCase().includes(q) && !t.requester.toLowerCase().includes(q) && !t.email.toLowerCase().includes(q)) return false;
    }
    if (filterStatus && t.status !== filterStatus) return false;
    if (filterPriority && t.priority !== filterPriority) return false;
    if (filterChannel && t.channel !== filterChannel) return false;
    if (quickFilter === 'mine'       && t.agent !== 'Ana Vargas') return false;
    if (quickFilter === 'unassigned' && t.agent) return false;
    if (quickFilter === 'sla'        && t.sla !== 'vencendo' && t.sla !== 'vencido') return false;
    if (quickFilter === 'urgent'     && t.priority !== 'urgente' && t.priority !== 'alta') return false;
    return true;
  });

  const preview = selected ? tickets.find(t => t.id === selected) : null;

  const QuickBtn = ({ id, label }) => (
    <button
      className={'filter-chip' + (quickFilter === id ? ' active' : '')}
      onClick={() => setQuickFilter(q => q === id ? '' : id)}
    >{label}</button>
  );

  return (
    <div style={{ display:'flex', gap:16, alignItems:'flex-start' }}>

      {/* ── Main table ── */}
      <div style={{ flex:1, minWidth:0 }}>
        <div className="table-wrap">
          <div className="table-toolbar" style={{ flexWrap:'wrap', gap:8 }}>
            <div className="search" style={{ maxWidth:320 }}>
              <Icon name="search" size={14}/>
              <input
                placeholder="Buscar por assunto, cliente, tenant ou e-mail"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <select className="select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
              <option value="">Status</option>
              <option value="novo">Novo</option>
              <option value="aberto">Aberto</option>
              <option value="aguardando_cliente">Ag. Cliente</option>
              <option value="aguardando_suporte">Ag. Suporte</option>
              <option value="em_analise_tecnica">Em Análise</option>
              <option value="resolvido">Resolvido</option>
              <option value="fechado">Fechado</option>
            </select>
            <select className="select" value={filterPriority} onChange={e => setFilterPriority(e.target.value)}>
              <option value="">Prioridade</option>
              <option value="baixa">Baixa</option>
              <option value="media">Média</option>
              <option value="alta">Alta</option>
              <option value="urgente">Urgente</option>
            </select>
            <select className="select" value={filterChannel} onChange={e => setFilterChannel(e.target.value)}>
              <option value="">Canal</option>
              <option value="Chat">Chat</option>
              <option value="E-mail">E-mail</option>
            </select>
            <div style={{ width:1, height:22, background:'var(--border)', margin:'0 2px' }} />
            <div className="filter-chips">
              <QuickBtn id="mine"       label="Meus tickets"/>
              <QuickBtn id="unassigned" label="Não atribuídos"/>
              <QuickBtn id="sla"        label="SLA vencendo"/>
              <QuickBtn id="urgent"     label="Alta prioridade"/>
            </div>
            <span style={{ fontSize:12,color:'var(--text-muted)',marginLeft:'auto' }}>{filtered.length} tickets</span>
          </div>

          <table className="data">
            <thead>
              <tr>
                <th>ID</th>
                <th>Assunto</th>
                <th>Tenant / Loja</th>
                <th>Solicitante</th>
                <th>Status</th>
                <th>Prioridade</th>
                <th>Responsável</th>
                <th>SLA</th>
                <th>Atualização</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(t => (
                <tr
                  key={t.id}
                  onClick={() => setSelected(s => s === t.id ? null : t.id)}
                  style={{ cursor:'pointer', background: selected === t.id ? 'color-mix(in srgb, var(--primary) 6%, var(--bg-elevated))' : undefined }}
                >
                  <td>
                    <span className="mono" style={{ fontSize:12,color:'var(--text-muted)',fontWeight:500 }}>{t.id}</span>
                  </td>
                  <td>
                    <div style={{ fontWeight:500,fontSize:13,maxWidth:220,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{t.subject}</div>
                    <div style={{ fontSize:11,color:'var(--text-muted)',marginTop:1 }}>{t.category}</div>
                  </td>
                  <td>
                    <div style={{ fontSize:13,fontWeight:500 }}>{t.tenant}</div>
                    <span className="badge neutral" style={{ fontSize:10 }}>{t.plan}</span>
                  </td>
                  <td>
                    <div style={{ fontSize:13 }}>{t.requester}</div>
                    <div style={{ fontSize:11,color:'var(--text-muted)' }}>{t.channel}</div>
                  </td>
                  <td><TicketStatusBadge status={t.status}/></td>
                  <td><TicketPriorityBadge priority={t.priority}/></td>
                  <td><AgentAvatar agent={t.agent}/></td>
                  <td><SLAChip sla={t.sla} time={t.slaTime}/></td>
                  <td style={{ fontSize:12,color:'var(--text-muted)',whiteSpace:'nowrap' }}>{t.lastUpdate}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={9} style={{ textAlign:'center',padding:'40px 20px',color:'var(--text-muted)' }}>
                  <div style={{ marginBottom:8 }}><Icon name="messageCircle" size={28} style={{ opacity:.25 }}/></div>
                  Nenhum ticket encontrado
                </td></tr>
              )}
            </tbody>
          </table>
          <div className="pagination">
            <span>Mostrando {filtered.length} de {tickets.length}</span>
            <div className="pages">
              <button className="active">1</button>
              <button>2</button>
              <button>3</button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Preview panel ── */}
      {preview && (
        <div className="card" style={{ width:340,flexShrink:0,overflow:'hidden' }}>
          <div style={{ padding:'12px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:6,flexWrap:'wrap' }}>
            <span className="mono" style={{ fontSize:12,color:'var(--text-muted)',fontWeight:600 }}>{preview.id}</span>
            <TicketStatusBadge status={preview.status} sm/>
            <TicketPriorityBadge priority={preview.priority}/>
            <button className="icon-action" style={{ marginLeft:'auto' }} onClick={() => setSelected(null)}><Icon name="x" size={14}/></button>
          </div>

          <div style={{ padding:'14px',borderBottom:'1px solid var(--border)' }}>
            <div style={{ fontWeight:600,fontSize:14,marginBottom:10,lineHeight:1.4 }}>{preview.subject}</div>
            {[
              { label:'Tenant',      value: preview.tenant },
              { label:'Plano',       value: preview.plan },
              { label:'Solicitante', value: preview.requester },
              { label:'Canal',       value: preview.channel },
              { label:'Responsável', value: preview.agent || '—' },
              { label:'SLA',         value: <SLAChip sla={preview.sla} time={preview.slaTime}/> },
            ].map(r => (
              <div key={r.label} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:12,padding:'4px 0' }}>
                <span style={{ color:'var(--text-muted)' }}>{r.label}</span>
                <span style={{ fontWeight:500,color:'var(--text)' }}>{r.value}</span>
              </div>
            ))}
          </div>

          <div style={{ padding:'12px 14px',borderBottom:'1px solid var(--border)' }}>
            <div style={{ fontSize:11,color:'var(--text-muted)',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.04em',marginBottom:6 }}>Última mensagem</div>
            <div style={{ fontSize:12,color:'var(--text-secondary)',lineHeight:1.5,display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical',overflow:'hidden' }}>
              {preview.preview}
            </div>
          </div>

          <div style={{ padding:'10px 14px',display:'flex',gap:6,flexWrap:'wrap' }}>
            <button className="btn sm primary" style={{ flex:1,justifyContent:'center' }} onClick={() => onOpenDetail && onOpenDetail(preview)}>
              <Icon name="messageCircle" size={12}/>Abrir ticket
            </button>
            <button className="btn sm" title="Atribuir" onClick={() => {
              if (onTicketUpdate) onTicketUpdate(preview.id, { agent: 'Ana Vargas', lastUpdate: 'Agora' });
              onToast && onToast('Ticket atribuído para você');
            }}>
              <Icon name="users" size={12}/>
            </button>
            <button className="btn sm" title="Escalar" onClick={() => {
              if (onTicketUpdate) onTicketUpdate(preview.id, { status: 'em_analise_tecnica', priority: 'urgente', lastUpdate: 'Agora' });
              onToast && onToast('Ticket escalado para análise técnica');
            }}>
              <Icon name="arrowUp" size={12}/>
            </button>
            <button className="btn sm danger-outline" title="Encerrar" onClick={() => {
              if (onTicketUpdate) onTicketUpdate(preview.id, { status: 'resolvido', lastUpdate: 'Agora' });
              setSelected(null);
              onToast && onToast('Ticket encerrado');
            }}>
              <Icon name="check" size={12}/>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Ticket Detail Page ────────────────────────────────────────────────────────
const TicketDetailPage = ({ ticket: initialTicket, onBack, onToast, onNav, onUpdate }) => {
  const [replyMode, setReplyMode] = React.useState('public');
  const [replyText, setReplyText] = React.useState('');
  const [ticket, setTicket] = React.useState(initialTicket);
  const [messages, setMessages] = React.useState(TICKET_MESSAGES || []);
  const [showMacroMenu, setShowMacroMenu] = React.useState(false);
  const [assignAgent, setAssignAgent] = React.useState(ticket.agent || '');
  const [billingBlocked, setBillingBlocked] = React.useState(false);
  const [ticketArticles, setTicketArticles] = React.useState(() => (window.TICKET_ARTICLES || {})[initialTicket.id] || []);
  const hasBillingAccess = false; // Suporte N1/N2 não tem acesso a dados financeiros
  React.useEffect(() => {
    runtimeHooks.notifyTicketArticle = (ticketId, article) => {
      if (ticketId === ticket.id) {
        setTicketArticles(arts => {
          const idx = arts.findIndex(a => a.id === article.id);
          return idx >= 0 ? arts.map(a => a.id === article.id ? article : a) : [...arts, article];
        });
      }
    };
    return () => { delete runtimeHooks.notifyTicketArticle; };
  }, [ticket.id]);
  const MACROS = (window.MACROS || []).slice(0, 5);
  const AGENTS = SUPPORT_AGENTS || [];

  // Propaga mudanças no ticket local para a lista
  const updateAndSync = (updates) => {
    setTicket(t => {
      const updated = { ...t, ...updates };
      if (onUpdate) onUpdate(updated.id, updates);
      return updated;
    });
  };

  const suggestedArticles = [
    'Como configurar domínio próprio',
    'Como alterar plano e cobrança',
    'Como configurar métodos de pagamento',
  ];

  const handleSend = () => {
    if (!replyText.trim()) return;
    const isInternal = replyMode === 'internal';
    const newMsg = {
      id: 'msg_' + Date.now(),
      type: isInternal ? 'internal' : 'agent',
      author: 'Ana Vargas',
      initials: 'AV',
      agentColor: '#1B3D60',
      time: 'Agora',
      content: replyText,
    };
    setMessages(ms => [...ms, newMsg]);
    const updates = { status: isInternal ? ticket.status : 'aguardando_cliente', lastUpdate: 'Agora' };
    updateAndSync(updates);
    onToast && onToast(isInternal ? 'Nota interna salva' : 'Resposta enviada ao cliente');
    setReplyText('');
  };

  const handleClose = () => {
    updateAndSync({ status: 'resolvido', lastUpdate: 'Agora' });
    onToast && onToast('Ticket encerrado como Resolvido');
  };

  const handleEscalate = () => {
    const agent = assignAgent || 'Rafael Tavares';
    updateAndSync({ priority: 'urgente', agent, lastUpdate: 'Agora' });
    onToast && onToast('Ticket escalado para Suporte N2');
  };

  const handleAssign = () => {
    if (!assignAgent) return;
    updateAndSync({ agent: assignAgent, lastUpdate: 'Agora' });
    onToast && onToast(`Ticket atribuído para ${assignAgent}`);
  };

  const handleInsertMacro = (macro) => {
    setReplyText(t => t + (t ? '\n\n' : '') + macro.body);
    setShowMacroMenu(false);
    onToast && onToast(`Macro "${macro.name}" inserida`);
  };

  const handleOpenRepairs = () => {
    if (onNav) {
      onNav({
        page: 'repairs',
        contextTicket: {
          id: ticket.id,
          tenant: ticket.tenant,
          subject: ticket.subject,
          tenantId: ticket.tenantId || null,
          plan: ticket.plan,
        }
      });
    } else {
      onToast && onToast('Abrindo Repairs & Diagnóstico…');
    }
  };

  const navyBg = 'var(--brand-navy)';

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:20,paddingBottom:16,borderBottom:'1px solid var(--border)',flexWrap:'wrap' }}>
        <button className="btn ghost sm" onClick={onBack} style={{ gap:4,padding:'0 10px' }}>
          <Icon name="chevronLeft" size={14}/>Tickets
        </button>
        <div style={{ width:1,height:20,background:'var(--border)' }}/>
        <span className="mono" style={{ fontSize:13,color:'var(--text-muted)',fontWeight:600 }}>{ticket.id}</span>
        <div style={{ flex:1,fontWeight:600,fontSize:15,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{ticket.subject}</div>
        <TicketStatusBadge status={ticket.status}/>
        <TicketPriorityBadge priority={ticket.priority}/>
        <div style={{ display:'flex',gap:6,flexWrap:'wrap' }}>
          <div style={{ position:'relative' }}>
            <select
              className="select"
              style={{ height:30,fontSize:12,paddingRight:28 }}
              value={assignAgent}
              onChange={e => { setAssignAgent(e.target.value); }}
            >
              <option value="">Atribuir…</option>
              {AGENTS.map(a => <option key={a.id} value={a.name}>{a.name}</option>)}
            </select>
          </div>
          {assignAgent && assignAgent !== ticket.agent && (
            <button className="btn sm primary" onClick={handleAssign}>
              <Icon name="users" size={13}/>Atribuir
            </button>
          )}
          <button className="btn sm" onClick={handleEscalate}>
            <Icon name="arrowUp" size={13}/>Escalar
          </button>
          <button className="btn sm danger-outline" onClick={handleClose} disabled={ticket.status==='resolvido'||ticket.status==='fechado'}>
            <Icon name="check" size={13}/>{ticket.status==='resolvido'?'Resolvido':'Encerrar'}
          </button>
        </div>
      </div>

      {/* 2-col layout */}
      <div style={{ display:'grid',gridTemplateColumns:'1fr 300px',gap:20,alignItems:'start' }}>

        {/* Left: conversation */}
        <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'12px 18px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:8 }}>
              <Icon name="messageCircle" size={15} style={{ color:'var(--text-muted)' }}/>
              <span style={{ fontWeight:600,fontSize:14 }}>Conversa</span>
              <span style={{ fontSize:12,color:'var(--text-muted)' }}>{messages.filter(m => m.type !== 'system').length} mensagens</span>
            </div>
            <div style={{ padding:'16px 18px',display:'flex',flexDirection:'column',gap:16 }}>
              {messages.map(msg => {
                if (msg.type === 'system') return (
                  <div key={msg.id} style={{ display:'flex',alignItems:'center',gap:8 }}>
                    <div style={{ flex:1,height:1,background:'var(--border)' }}/>
                    <span style={{ fontSize:11,color:'var(--text-muted)',whiteSpace:'nowrap',padding:'0 8px' }}>{msg.content} · {msg.time}</span>
                    <div style={{ flex:1,height:1,background:'var(--border)' }}/>
                  </div>
                );

                if (msg.type === 'internal') return (
                  <div key={msg.id} style={{ background:'#fffbeb',border:'1px solid #fde68a',borderRadius:10,padding:'12px 14px' }}>
                    <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:6 }}>
                      <div style={{ width:22,height:22,borderRadius:'50%',background:'#b45309',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700,color:'white' }}>{msg.initials}</div>
                      <span style={{ fontSize:12,fontWeight:600,color:'#78350f' }}>{msg.author}</span>
                      <span style={{ background:'#fef3c7',color:'#b45309',fontSize:10,fontWeight:600,padding:'1px 8px',borderRadius:20 }}>Nota interna</span>
                      <span style={{ fontSize:11,color:'#b45309',opacity:.6,marginLeft:'auto' }}>{msg.time}</span>
                    </div>
                    <div style={{ fontSize:13,color:'#78350f',lineHeight:1.6,whiteSpace:'pre-wrap' }}>{msg.content}</div>
                  </div>
                );

                const isCust = msg.type === 'customer';
                return (
                  <div key={msg.id} style={{ display:'flex',gap:10,flexDirection:isCust ? 'row' : 'row-reverse' }}>
                    <div style={{ width:28,height:28,borderRadius:'50%',background:isCust ? '#6d28d9' : (msg.agentColor || navyBg),display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,color:'white',flexShrink:0,marginTop:2 }}>
                      {msg.initials}
                    </div>
                    <div style={{ flex:1,maxWidth:'78%' }}>
                      <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:4,flexDirection:isCust ? 'row' : 'row-reverse' }}>
                        <span style={{ fontSize:12,fontWeight:600 }}>{msg.author}</span>
                        <span style={{ fontSize:11,color:'var(--text-muted)' }}>{msg.time}</span>
                      </div>
                      <div style={{
                        background: isCust ? 'var(--bg-subtle)' : navyBg,
                        color:      isCust ? 'var(--text)' : 'white',
                        borderRadius: isCust ? '3px 12px 12px 12px' : '12px 3px 12px 12px',
                        padding:'12px 14px',fontSize:13,lineHeight:1.6,whiteSpace:'pre-wrap',
                      }}>{msg.content}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Reply editor */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ display:'flex',borderBottom:'1px solid var(--border)' }}>
              {[
                { id:'public',   label:'Resposta pública', icon:'send' },
                { id:'internal', label:'Nota interna',     icon:'lock' },
              ].map(m => (
                <button key={m.id} onClick={() => setReplyMode(m.id)} style={{
                  display:'flex',alignItems:'center',gap:6,
                  padding:'10px 16px',border:'none',background:'transparent',
                  fontSize:13,fontWeight:replyMode===m.id ? 600 : 500,
                  color:replyMode===m.id ? 'var(--text)' : 'var(--text-muted)',
                  borderBottom:replyMode===m.id ? '2px solid var(--brand-navy)' : '2px solid transparent',
                  marginBottom:-1,cursor:'pointer',transition:'color 120ms',
                }}>
                  <Icon name={m.icon} size={13}/>{m.label}
                </button>
              ))}
            </div>
            <textarea
              value={replyText}
              onChange={e => setReplyText(e.target.value)}
              placeholder={replyMode==='public' ? 'Escreva sua resposta para o cliente…' : 'Escreva uma nota interna visível apenas para a equipe…'}
              style={{
                width:'100%',minHeight:120,padding:'14px 16px',
                border:'none',outline:'none',resize:'vertical',
                background:replyMode==='internal' ? '#fffdf0' : 'var(--bg-elevated)',
                color:'var(--text)',fontSize:13,fontFamily:'inherit',lineHeight:1.6,
              }}
            />
            <div style={{ padding:'10px 14px',borderTop:'1px solid var(--border)',display:'flex',gap:8,alignItems:'center',background:'var(--bg-subtle)',flexWrap:'wrap',position:'relative' }}>
              <button className="btn primary sm" onClick={handleSend} disabled={!replyText.trim()}>
                <Icon name="send" size={13}/>{replyMode==='public' ? 'Enviar resposta' : 'Salvar nota'}
              </button>
              <div style={{ position:'relative' }}>
                <button className="btn sm" onClick={() => setShowMacroMenu(m=>!m)}>
                  <Icon name="zap" size={13}/>Inserir macro
                </button>
                {showMacroMenu && MACROS.length > 0 && (
                  <div style={{ position:'absolute',bottom:'calc(100% + 6px)',left:0,background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:10,boxShadow:'var(--shadow-lg)',minWidth:220,zIndex:50,overflow:'hidden' }}>
                    {MACROS.map(m => (
                      <button key={m.id} style={{ display:'block',width:'100%',textAlign:'left',padding:'9px 14px',border:'none',background:'transparent',fontSize:13,cursor:'pointer',color:'var(--text)' }}
                        onMouseEnter={e=>e.currentTarget.style.background='var(--bg-hover)'}
                        onMouseLeave={e=>e.currentTarget.style.background='transparent'}
                        onClick={()=>handleInsertMacro(m)}>
                        <div style={{ fontWeight:500 }}>{m.name}</div>
                        <div style={{ fontSize:11,color:'var(--text-muted)',marginTop:1 }}>{m.category}</div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <button className="btn sm" onClick={() => onToast && onToast('Selecionando arquivo…')}>
                <Icon name="paperclip" size={13}/>Anexar
              </button>
              <button className="btn sm" onClick={() => onToast && onToast('Artigo sugerido inserido')}>
                <Icon name="bookOpen" size={13}/>Sugerir artigo
              </button>
            </div>
          </div>
        </div>

        {/* Right: sidebar */}
        <div style={{ display:'flex',flexDirection:'column',gap:12 }}>
          {/* Ticket details */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)' }}>
              <div style={{ fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Detalhes do ticket</div>
            </div>
            <div style={{ padding:'10px 14px' }}>
              {[
                { label:'Tenant',      value: ticket.tenant },
                { label:'Plano',       value: ticket.plan },
                { label:'Solicitante', value: ticket.requester },
                { label:'E-mail',      value: <span style={{ fontSize:11 }}>{ticket.email}</span> },
                { label:'Canal',       value: ticket.channel },
                { label:'Responsável', value: ticket.agent || '—' },
                { label:'Categoria',   value: ticket.category },
              ].map(r => (
                <div key={r.label} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:12,padding:'6px 0',borderBottom:'1px solid var(--border)' }}>
                  <span style={{ color:'var(--text-muted)' }}>{r.label}</span>
                  <span style={{ fontWeight:500,color:'var(--text)',textAlign:'right' }}>{r.value}</span>
                </div>
              ))}
              <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:12,padding:'6px 0',borderBottom:'1px solid var(--border)' }}>
                <span style={{ color:'var(--text-muted)' }}>SLA</span>
                <SLAChip sla={ticket.sla} time={ticket.slaTime}/>
              </div>
              <div style={{ paddingTop:10,display:'flex',flexWrap:'wrap',gap:4 }}>
                {(ticket.tags||[]).map(tag => (
                  <span key={tag} style={{ background:'var(--bg-subtle)',color:'var(--text-secondary)',fontSize:11,padding:'2px 8px',borderRadius:20,border:'1px solid var(--border)',fontWeight:500 }}>{tag}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Artigos sugeridos */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:7 }}>
              <Icon name="bookOpen" size={13} style={{ color:'var(--text-muted)' }}/>
              <div style={{ fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Artigos sugeridos</div>
            </div>
            <div>
              {suggestedArticles.map((art,i) => (
                <div key={i}
                  onClick={() => onToast && onToast(`Abrindo: ${art}`)}
                  style={{ padding:'8px 14px',display:'flex',alignItems:'center',gap:9,cursor:'pointer',borderBottom:'1px solid var(--border)' }}
                  onMouseEnter={e => e.currentTarget.style.background='var(--bg-hover)'}
                  onMouseLeave={e => e.currentTarget.style.background='transparent'}
                >
                  <Icon name="fileText" size={13} style={{ color:'var(--text-muted)',flexShrink:0 }}/>
                  <span style={{ fontSize:12,color:'var(--text)',flex:1 }}>{art}</span>
                  <Icon name="arrowRight" size={12} style={{ color:'var(--text-muted)',flexShrink:0 }}/>
                </div>
              ))}
              <div style={{ padding:'8px 14px' }}>
                <button className="btn sm" style={{ width:'100%',justifyContent:'center' }} onClick={() => {
                  if (onNav) {
                    onNav({
                      page: 'knowledge-base',
                      articleContext: {
                        id: ticket.id,
                        subject: ticket.subject,
                        category: ticket.category,
                        preview: ticket.preview,
                        tenant: ticket.tenant,
                        priority: ticket.priority,
                        tags: ticket.tags,
                      }
                    });
                  } else {
                    onToast && onToast('Abrindo editor de artigo…');
                  }
                }}>
                  <Icon name="plus" size={12}/>Criar artigo deste ticket
                </button>
              </div>
            </div>
          </div>

          {/* Artigo criado a partir deste ticket */}
          {ticketArticles.length > 0 && (
            <div className="card" style={{ overflow:'hidden' }}>
              <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:7 }}>
                <Icon name="bookOpen" size={13} style={{ color:'var(--success)' }}/>
                <div style={{ fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Artigo criado</div>
              </div>
              <div>
                {ticketArticles.map((art, i) => (
                  <div key={i} style={{ padding:'9px 14px',display:'flex',alignItems:'center',gap:9,borderBottom:'1px solid var(--border)' }}>
                    <Icon name="fileText" size={13} style={{ color:'var(--success)',flexShrink:0 }}/>
                    <div style={{ flex:1,minWidth:0 }}>
                      <div style={{ fontSize:12,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{art.title}</div>
                      <span className={`badge ${art.status==='publicado'?'success':'neutral'}`} style={{ fontSize:9,marginTop:2 }}><span className="dot"/>{art.status}</span>
                    </div>
                    <button className="icon-action" title="Ver na KB" onClick={() => onNav && onNav({ page: 'knowledge-base' })}><Icon name="arrowRight" size={12}/></button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Loja / Tenant */}
          <div className="card" style={{ overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:'1px solid var(--border)' }}>
              <div style={{ fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)' }}>Loja / Tenant</div>
            </div>
            <div style={{ padding:'12px 14px' }}>
              <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:12 }}>
                <div style={{ width:34,height:34,borderRadius:8,background:'var(--brand-navy)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'white' }}>
                  {ticket.tenant.split(' ').map(w=>w[0]).join('').slice(0,2)}
                </div>
                <div>
                  <div style={{ fontWeight:600,fontSize:13 }}>{ticket.tenant}</div>
                  <span className="badge info" style={{ fontSize:10 }}><span className="dot"/>{ticket.plan}</span>
                </div>
              </div>
              <div style={{ display:'flex',flexDirection:'column',gap:3 }}>
                {[
                  { label:'Ver tenant',   icon:'store',    action: () => {
                    const allStores = STORES || [];
                    const store = allStores.find(s => String(s.tenant_id) === String(ticket.tenantId) || String(s.id) === String(ticket.tenantId));
                    if (onNav && store) onNav({ page: 'cockpit', store });
                    else if (onNav) onNav({ page: 'lojas' });
                    else onToast && onToast('Abrindo tenant…');
                  }},
                  { label:'Ver billing',  icon:'cardCoin', action: () => {
                    if (hasBillingAccess) {
                      if (onNav) onNav({ page: 'billing', tenantContext: { id: ticket.tenantId, name: ticket.tenant } });
                      else onToast && onToast('Abrindo billing…');
                    } else {
                      setBillingBlocked(true);
                    }
                  }},
                  { label:'Ver logs',     icon:'terminal', action: () => {
                    if (onNav) onNav({ page: 'observabilidade', tenantContext: { id: ticket.tenantId, name: ticket.tenant } });
                    else onToast && onToast('Abrindo logs…');
                  }},
                  { label:'Abrir repairs',icon:'wrench',   action: handleOpenRepairs },
                ].map(link => (
                  <button key={link.label} className="btn sm ghost" style={{ justifyContent:'flex-start' }} onClick={link.action}>
                    <Icon name={link.icon} size={13}/>{link.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Billing acesso restrito */}
      {billingBlocked && (
        <div onClick={() => setBillingBlocked(false)} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.5)',backdropFilter:'blur(3px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
          <div onClick={e => e.stopPropagation()} style={{ width:440,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',overflow:'hidden' }}>
            <div style={{ padding:'28px 28px 20px',textAlign:'center' }}>
              <div style={{ width:52,height:52,borderRadius:'50%',background:'var(--warning-bg)',margin:'0 auto 16px',display:'flex',alignItems:'center',justifyContent:'center' }}>
                <Icon name="shield" size={24} style={{ color:'var(--warning)' }}/>
              </div>
              <h3 style={{ fontSize:17,fontWeight:700,marginBottom:8 }}>Acesso restrito</h3>
              <p style={{ fontSize:13,color:'var(--text-secondary)',lineHeight:1.6,margin:0 }}>
                Seu perfil de suporte não tem acesso a dados financeiros sensíveis deste tenant. Billing requer permissão de nível Admin ou Financeiro.
              </p>
            </div>
            <div style={{ padding:'12px 24px 20px',display:'flex',gap:10,justifyContent:'center' }}>
              <button className="btn ghost" onClick={() => setBillingBlocked(false)}>
                <Icon name="chevronLeft" size={13}/>Voltar ao ticket
              </button>
              <button className="btn" onClick={() => { setBillingBlocked(false); onToast && onToast('Solicitação de acesso enviada'); }}>
                <Icon name="send" size={13}/>Solicitar acesso
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Tab Inbox ─────────────────────────────────────────────────────────────────
const InboxTab = ({ onOpenDetail, onToast, onNav, tickets: ticketsProp, onTicketUpdate }) => {
  const tickets = ticketsProp || TICKETS || [];
  const [selected, setSelected] = React.useState(null);
  const [replyText, setReplyText] = React.useState('');
  const [filter, setFilter]             = React.useState('all');
  const [billingBlocked, setBillingBlocked] = React.useState(false);
  const [billingTenant,  setBillingTenant]  = React.useState(null);

  // Sincroniza selected com o estado atualizado da lista
  const selectedTicket = selected ? tickets.find(t => t.id === selected.id) || selected : null;

  const updateTicket = (id, updates) => {
    if (onTicketUpdate) {
      onTicketUpdate(id, updates);
    } else {
      if (TICKETS) setTICKETS(TICKETS.map(t => t.id === id ? { ...t, ...updates } : t));
    }
    setSelected(s => s && s.id === id ? { ...s, ...updates } : s);
  };

  const FILTERS = [
    { id:'all',        label:'Todos'         },
    { id:'unassigned', label:'Não atribuídos'},
    { id:'mine',       label:'Meus'          },
    { id:'urgent',     label:'Urgentes'      },
    { id:'sla',        label:'SLA vencido'   },
  ];

  const filtered = tickets.filter(t => {
    if (filter==='unassigned') return !t.agent;
    if (filter==='mine')       return t.agent==='Ana Vargas';
    if (filter==='urgent')     return t.priority==='urgente';
    if (filter==='sla')        return t.sla==='vencido';
    return true;
  });

  const msgs = TICKET_MESSAGES || [];

  return (
    <React.Fragment>
    <div style={{ display:'grid',gridTemplateColumns:'300px 1fr 280px',height:'calc(100vh - 220px)',border:'1px solid var(--border)',borderRadius:12,overflow:'hidden',background:'var(--bg-elevated)' }}>

      {/* Left: list */}
      <div style={{ borderRight:'1px solid var(--border)',display:'flex',flexDirection:'column',background:'var(--bg-elevated)' }}>
        <div style={{ padding:'10px 12px',borderBottom:'1px solid var(--border)' }}>
          <div className="search">
            <Icon name="search" size={14}/>
            <input placeholder="Buscar conversa…" style={{ width:'100%' }}/>
          </div>
        </div>
        <div style={{ padding:'8px 10px',borderBottom:'1px solid var(--border)',display:'flex',gap:4,overflowX:'auto' }}>
          {FILTERS.map(f => (
            <button key={f.id} onClick={() => setFilter(f.id)} style={{
              padding:'3px 10px',border:'1px solid',borderRadius:20,
              fontSize:11,fontWeight:500,whiteSpace:'nowrap',cursor:'pointer',
              background: filter===f.id ? 'var(--brand-navy)' : 'transparent',
              borderColor: filter===f.id ? 'var(--brand-navy)' : 'var(--border-strong)',
              color: filter===f.id ? 'white' : 'var(--text-secondary)',
            }}>{f.label}</button>
          ))}
        </div>
        <div style={{ flex:1,overflowY:'auto' }}>
          {filtered.map(t => {
            const sc = TICKET_STATUS_CFG[t.status]   || TICKET_STATUS_CFG.aberto;
            const pc = TICKET_PRIORITY_CFG[t.priority]|| TICKET_PRIORITY_CFG.media;
            const isSel = selected?.id === t.id;
            return (
              <div key={t.id} onClick={() => setSelected(t)} style={{
                padding:'11px 13px',borderBottom:'1px solid var(--border)',cursor:'pointer',
                background: isSel ? 'color-mix(in srgb, var(--primary) 7%, var(--bg-elevated))' : 'transparent',
                borderLeft: isSel ? '3px solid var(--brand-navy)' : '3px solid transparent',
                transition:'background 80ms',
              }}>
                <div style={{ display:'flex',alignItems:'flex-start',gap:6,marginBottom:3 }}>
                  <div style={{ flex:1,fontWeight:600,fontSize:12,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{t.subject}</div>
                  <span className={`badge ${pc.cls}`} style={{ fontSize:9,flexShrink:0 }}><span className="dot"/>{pc.label}</span>
                </div>
                <div style={{ display:'flex',alignItems:'center',gap:5,marginBottom:3 }}>
                  <span style={{ fontSize:11,color:'var(--text-secondary)',fontWeight:500 }}>{t.tenant}</span>
                  <span style={{ fontSize:10,color:'var(--text-muted)' }}>·</span>
                  <span style={{ fontSize:10,color:'var(--text-muted)' }}>{t.channel}</span>
                </div>
                <div style={{ fontSize:11,color:'var(--text-muted)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',marginBottom:5 }}>{t.preview}</div>
                <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between' }}>
                  <span className={`badge ${sc.cls}`} style={{ fontSize:9 }}><span className="dot"/>{sc.label}</span>
                  <span style={{ fontSize:10,color:'var(--text-muted)' }}>{t.lastUpdate}</span>
                </div>
              </div>
            );
          })}
          {filtered.length===0 && (
            <div style={{ padding:'40px 20px',textAlign:'center',color:'var(--text-muted)',fontSize:12 }}>Nenhuma conversa</div>
          )}
        </div>
      </div>

      {/* Center: conversation */}
      <div style={{ display:'flex',flexDirection:'column',background:'var(--bg)' }}>
        {selected ? (
          <>
            <div style={{ padding:'10px 16px',borderBottom:'1px solid var(--border)',background:'var(--bg-elevated)',display:'flex',alignItems:'center',gap:10 }}>
              <div style={{ flex:1,minWidth:0 }}>
                <div style={{ fontWeight:600,fontSize:13,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{selected.subject}</div>
                <div style={{ fontSize:11,color:'var(--text-muted)' }}>{selected.tenant} · {selected.requester}</div>
              </div>
              <TicketStatusBadge status={selected.status} sm/>
              <button className="btn sm" onClick={() => onOpenDetail && onOpenDetail(selectedTicket)}>
                <Icon name="maximize" size={12}/>Abrir completo
              </button>
            </div>

            <div style={{ flex:1,overflowY:'auto',padding:'16px',display:'flex',flexDirection:'column',gap:12 }}>
              {msgs.map(msg => {
                if (msg.type==='system') return (
                  <div key={msg.id} style={{ textAlign:'center',fontSize:11,color:'var(--text-muted)',padding:'2px 0' }}>{msg.content}</div>
                );
                if (msg.type==='internal') return (
                  <div key={msg.id} style={{ background:'#fffbeb',border:'1px solid #fde68a',borderRadius:8,padding:'9px 12px' }}>
                    <div style={{ fontSize:10,color:'#78350f',fontWeight:600,marginBottom:3 }}>Nota interna · {msg.author} · {msg.time}</div>
                    <div style={{ fontSize:12,color:'#78350f',lineHeight:1.5 }}>{msg.content}</div>
                  </div>
                );
                const isCust = msg.type==='customer';
                return (
                  <div key={msg.id} style={{ display:'flex',gap:8,flexDirection:isCust ? 'row' : 'row-reverse' }}>
                    <div style={{ width:26,height:26,borderRadius:'50%',background:isCust ? '#6d28d9' : 'var(--brand-navy)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700,color:'white',flexShrink:0,marginTop:2 }}>{msg.initials}</div>
                    <div style={{ maxWidth:'74%' }}>
                      <div style={{ fontSize:10,color:'var(--text-muted)',marginBottom:3,textAlign:isCust?'left':'right' }}>{msg.author} · {msg.time}</div>
                      <div style={{
                        background: isCust ? 'var(--bg-elevated)' : 'var(--brand-navy)',
                        color: isCust ? 'var(--text)' : 'white',
                        borderRadius: isCust ? '3px 10px 10px 10px' : '10px 3px 10px 10px',
                        padding:'10px 12px',fontSize:13,lineHeight:1.5,whiteSpace:'pre-wrap',
                        boxShadow:'var(--shadow-xs)',
                      }}>{msg.content}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ borderTop:'1px solid var(--border)',background:'var(--bg-elevated)' }}>
              <textarea
                value={replyText}
                onChange={e => setReplyText(e.target.value)}
                placeholder="Resposta rápida… (Enter para enviar, Shift+Enter para nova linha)"
                style={{ width:'100%',height:68,padding:'12px 14px',border:'none',background:'transparent',color:'var(--text)',fontSize:13,fontFamily:'inherit',resize:'none',outline:'none' }}
                onKeyDown={e => { if (e.key==='Enter' && !e.shiftKey) { e.preventDefault(); if (replyText.trim()) { onToast&&onToast('Resposta enviada'); setReplyText(''); } } }}
              />
              <div style={{ padding:'8px 12px',borderTop:'1px solid var(--border)',display:'flex',gap:6,alignItems:'center',background:'var(--bg-subtle)' }}>
                <button className="btn sm primary" disabled={!replyText.trim()} onClick={() => {
                  if (!selectedTicket) return;
                  updateTicket(selectedTicket.id, { status: 'aguardando_cliente', lastUpdate: 'Agora' });
                  onToast&&onToast('Resposta enviada');
                  setReplyText('');
                }}>
                  <Icon name="send" size={12}/>Enviar
                </button>
                <button className="btn sm ghost" onClick={() => { onToast&&onToast('Nota interna salva'); }}>
                  <Icon name="lock" size={12}/>Nota
                </button>
                <button className="btn sm ghost" onClick={() => onToast&&onToast('Macro inserida')}>
                  <Icon name="zap" size={12}/>Macro
                </button>
                <div style={{ marginLeft:'auto' }}>
                  <button className="btn sm" onClick={() => {
                    if (!selectedTicket) return;
                    updateTicket(selectedTicket.id, { status: 'resolvido', lastUpdate: 'Agora' });
                    onToast&&onToast('Ticket encerrado como Resolvido');
                  }}>
                    <Icon name="check" size={12}/>{selectedTicket?.status === 'resolvido' ? 'Resolvido ✓' : 'Encerrar'}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div style={{ flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:10,color:'var(--text-muted)' }}>
            <Icon name="inbox" size={36} style={{ opacity:.18 }}/>
            <div style={{ fontWeight:500 }}>Selecione uma conversa</div>
          </div>
        )}
      </div>

      {/* Right: tenant context */}
      <div style={{ borderLeft:'1px solid var(--border)',overflowY:'auto',background:'var(--bg-elevated)' }}>
        {selectedTicket ? (
          <div style={{ padding:'14px' }}>
            <div style={{ fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.06em',color:'var(--text-muted)',marginBottom:12 }}>Contexto do tenant</div>
            <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:14 }}>
              <div style={{ width:36,height:36,borderRadius:8,background:'var(--brand-navy)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'white' }}>
                {(selectedTicket.tenant||'').split(' ').map(w=>w[0]).join('').slice(0,2)}
              </div>
              <div>
                <div style={{ fontWeight:600,fontSize:13 }}>{selectedTicket.tenant}</div>
                <span className="badge info" style={{ fontSize:10 }}><span className="dot"/>{selectedTicket.plan}</span>
              </div>
            </div>
            {[
              { label:'Solicitante',    value: selectedTicket.requester },
              { label:'E-mail',         value: <span style={{ fontSize:10 }}>{selectedTicket.email}</span> },
              { label:'Canal',          value: selectedTicket.channel },
              { label:'Saúde da conta', value: <span className="badge success" style={{ fontSize:10 }}><span className="dot"/>Boa</span> },
              { label:'Tickets abertos',value: '3' },
              { label:'Último login',   value: 'Há 2h' },
              { label:'Atividade',      value: 'Normal' },
            ].map(r => (
              <div key={r.label} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:11,padding:'5px 0',borderBottom:'1px solid var(--border)' }}>
                <span style={{ color:'var(--text-muted)' }}>{r.label}</span>
                <span style={{ fontWeight:500,color:'var(--text)' }}>{r.value}</span>
              </div>
            ))}
            <div style={{ marginTop:14,display:'flex',flexDirection:'column',gap:3 }}>
              {[
                { label:'Ver tenant',    icon:'store',    action: () => {
                  const allStores = STORES || [];
                  const store = allStores.find(s => String(s.tenant_id) === String(selectedTicket?.tenantId) || String(s.id) === String(selectedTicket?.tenantId));
                  if (onNav && store) onNav({ page: 'cockpit', store });
                  else if (onNav) onNav({ page: 'lojas' });
                  else onToast&&onToast('Ver tenant…');
                }},
                { label:'Ver billing',   icon:'cardCoin', action: () => { setBillingTenant({ name: selectedTicket?.tenant, id: selectedTicket?.tenantId }); setBillingBlocked(true); }  },
                { label:'Ver logs',      icon:'terminal', action: () => { if (onNav) onNav({ page: 'observabilidade', tenantContext: { id: selectedTicket?.tenantId, name: selectedTicket?.tenant } }); else onToast&&onToast('Ver logs…'); }},
                { label:'Abrir repairs', icon:'wrench',   action: () => { if (onNav) onNav({ page: 'repairs', contextTicket: { id: selectedTicket?.id, tenant: selectedTicket?.tenant, tenantId: selectedTicket?.tenantId, subject: selectedTicket?.subject, plan: selectedTicket?.plan, priority: selectedTicket?.priority } }); else onToast&&onToast('Abrir repairs…'); }},
              ].map(l => (
                <button key={l.label} className="btn sm ghost" style={{ justifyContent:'flex-start' }} onClick={l.action}>
                  <Icon name={l.icon} size={12}/>{l.label}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ padding:20,color:'var(--text-muted)',fontSize:12,textAlign:'center',marginTop:40 }}>
            Selecione um ticket para ver o contexto
          </div>
        )}
      </div>
    </div>

    {/* Modal: Acesso restrito — billing */}
    {billingBlocked && (
      <div onClick={() => setBillingBlocked(false)} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.5)',backdropFilter:'blur(3px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:440,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',overflow:'hidden' }}>
          <div style={{ padding:'28px 28px 20px',textAlign:'center' }}>
            <div style={{ width:52,height:52,borderRadius:'50%',background:'var(--warning-bg)',margin:'0 auto 16px',display:'flex',alignItems:'center',justifyContent:'center' }}>
              <Icon name="shield" size={24} style={{ color:'var(--warning)' }}/>
            </div>
            <h3 style={{ fontSize:17,fontWeight:700,marginBottom:8 }}>Acesso restrito</h3>
            {billingTenant?.name && (
              <div style={{ fontSize:12,fontWeight:600,color:'var(--text-muted)',marginBottom:10 }}>
                Tenant: <strong style={{ color:'var(--text)' }}>{billingTenant.name}</strong>
              </div>
            )}
            <p style={{ fontSize:13,color:'var(--text-secondary)',lineHeight:1.6,margin:0 }}>
              Seu perfil de suporte não tem acesso a dados financeiros sensíveis deste tenant. Billing requer permissão de nível Admin ou Financeiro.
            </p>
          </div>
          <div style={{ padding:'12px 24px 20px',display:'flex',gap:10,justifyContent:'center' }}>
            <button className="btn ghost" onClick={() => setBillingBlocked(false)}>
              <Icon name="chevronLeft" size={13}/>Voltar
            </button>
            <button className="btn" onClick={() => { setBillingBlocked(false); onToast && onToast('Solicitação de acesso enviada'); }}>
              <Icon name="send" size={13}/>Solicitar acesso
            </button>
          </div>
        </div>
      </div>
    )}
    </React.Fragment>
  );
};

export {
  AgentAvatar,
  InboxTab,
  SLAChip,
  TICKET_PRIORITY_CFG,
  TICKET_STATUS_CFG,
  TicketDetailPage,
  TicketPriorityBadge,
  TicketStatusBadge,
  TicketsTab,
};
